module.exports = __webpack_public_path__ + "static/media/TEMPLATE_4.51d248e5.webp";